import { Alert, Button, FormControl, Grid, TextField } from "@mui/material";
import { useFormik } from "formik";
import { validationSchemaSendMail } from "../validationsForm/ValidationMailSchema";
import CorreoMasivoService from "../../services/CorreoMasivoService";
import SweetAlertUtil from "../../utils/SweetAlert";

export const MailForm: React.FC<{}> = () => {
    const formik = useFormik<{ username: string }>({
        initialValues: {
            username: '',
        },
        validationSchema: validationSchemaSendMail,
        onSubmit: (values) => {
            console.log(values);
            Enviar(values.username);
        },
    });

    function Enviar(username: string){
        try {
            CorreoMasivoService.SendMailDiario(username)
            .then((values) => {
                if(values.status === 200){
                    SweetAlertUtil.alertaExito('Exito', 'Mail enviado');
                }else{
                    SweetAlertUtil.alertaAdvertencia('Alerta', values.message);
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } catch (error) {
            console.error(error)
        }       
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container>
                <Grid item sm={12}>
                    <FormControl fullWidth margin="normal" error={formik.touched.username && Boolean(formik.errors.username)}>
                        <TextField
                            id="username"
                            name="username"
                            label='Usuario'
                            type="text"
                            value={formik.values.username}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.touched.username && Boolean(formik.errors.username)}
                        />
                        {formik.touched.username && formik.errors.username && (
                            <Alert variant="filled" severity="error" style={{ marginTop: '1px' }}>
                                {formik.errors.username}
                            </Alert>
                        )}
                    </FormControl>
                </Grid>
            </Grid>
            <Button color="primary" variant="contained" fullWidth type="submit" sx={{ m: 2 }}>
                Enviar
            </Button>
        </form>
    );
}